export { OrderConfirmationPage as default } from 'pages/order-confirmation/order-confirmation';
